(() => {
  function formatMoney(cents, format) {
    if (!format) format = "${{amount}}";
    const value = cents / 100;

    function withComma(number) {
      const parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(Math.round(value)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(value.toFixed(2)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value))
      .replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2));
  }

  function initSort() {
    const select = document.getElementById("CustomSortBy");
    const grid = document.getElementById("product-grid");
    if (!select || !grid) return;

    const items = Array.from(grid.querySelectorAll(":scope > .grid__item"));
    items.forEach((item, index) => {
      item.dataset.originalIndex = index;
    });

    select.addEventListener("input", (event) => {
      event.stopPropagation();
    });

    select.addEventListener("change", (event) => {
      event.stopPropagation();
      const sorted = items.slice();

      switch (select.value) {
        case "price-asc":
          sorted.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
          break;
        case "price-desc":
          sorted.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
          break;
        case "title-asc":
          sorted.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
          break;
        case "title-desc":
          sorted.sort((a, b) => b.dataset.title.localeCompare(a.dataset.title));
          break;
        case "date-desc":
          sorted.sort((a, b) => Number(b.dataset.created) - Number(a.dataset.created));
          break;
        case "date-asc":
          sorted.sort((a, b) => Number(a.dataset.created) - Number(b.dataset.created));
          break;
        default:
          sorted.sort((a, b) => Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex));
      }

      sorted.forEach((item) => grid.appendChild(item));
    });
  }

  function updateVisibleCount() {
    const counter = document.getElementById("CustomProductCount");
    const grid = document.getElementById("product-grid");
    if (!counter || !grid) return;
    const visible = grid.querySelectorAll(
      ":scope > .grid__item:not(.is-price-hidden):not(.is-color-hidden)"
    ).length;
    counter.textContent = `${visible} ${visible === 1 ? "product" : "products"}`;
  }

  function initPriceFilter() {
    const wrapper = document.getElementById("CustomPriceFilter");
    const grid = document.getElementById("product-grid");
    if (!wrapper || !grid) return;

    const minInput = wrapper.querySelector("[data-price-min-input]");
    const maxInput = wrapper.querySelector("[data-price-max-input]");
    const range = wrapper.querySelector("[data-price-range]");
    const minLabel = wrapper.querySelector("[data-price-min-label]");
    const maxLabel = wrapper.querySelector("[data-price-max-label]");
    const moneyFormat = wrapper.getAttribute("data-money-format");
    const min = Number(wrapper.getAttribute("data-min"));
    const max = Number(wrapper.getAttribute("data-max"));
    if (!minInput || !maxInput) return;

    const gap = Math.max(1, Math.round((max - min) * 0.02));

    function paint() {
      let minValue = Number(minInput.value);
      let maxValue = Number(maxInput.value);

      if (maxValue - minValue < gap) {
        if (this === minInput) {
          minInput.value = maxValue - gap;
        } else {
          maxInput.value = minValue + gap;
        }
        minValue = Number(minInput.value);
        maxValue = Number(maxInput.value);
      }

      const priceRange = max - min || 1;
      const left = ((minValue - min) / priceRange) * 100;
      const right = ((maxValue - min) / priceRange) * 100;

      if (range) {
        range.style.left = `${left}%`;
        range.style.right = `${100 - right}%`;
      }
      if (minLabel) minLabel.textContent = formatMoney(minValue, moneyFormat);
      if (maxLabel) maxLabel.textContent = formatMoney(maxValue, moneyFormat);

      grid.querySelectorAll(":scope > .grid__item").forEach((item) => {
        const price = Number(item.dataset.price);
        item.classList.toggle(
          "is-price-hidden",
          price < minValue || price > maxValue
        );
      });
      updateVisibleCount();
    }

    minInput.addEventListener("input", paint);
    maxInput.addEventListener("input", paint);
    paint();
  }

  // Color swatches link to Shopify's native Color filter (see collection-color-filter.liquid),
  // so filtering happens server-side across the whole collection.

  const initialize = () => {
    initSort();
    initPriceFilter();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
